"use client";

import {
  Close as ReactClose,
  CloseCircle as ReactCloseCircle,
} from "./deprecated/Close";

export const Close = ReactClose;
export const CloseCircle = ReactCloseCircle;
